import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=7f72aff2&scoped=true&"
import script from "./Calculate.vue?vue&type=script&lang=ts&"
export * from "./Calculate.vue?vue&type=script&lang=ts&"
import style0 from "./Calculate.vue?vue&type=style&index=0&id=7f72aff2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72aff2",
  null
  
)

export default component.exports